import { SITE_URL } from './seoConfig';

export const normalizePathname = (pathname = '/') => {
  if (pathname === '/') return '/';

  const normalizedPathname = pathname.replace(/\/+$/, '');
  return normalizedPathname || '/';
};

export const getCanonicalPath = (pathname = '/') => {
  const normalizedPathname = normalizePathname(pathname);
  return normalizedPathname === '/' ? '/' : `${normalizedPathname}/`;
};

export const getCanonicalUrl = (pathname = '/') => (
  `${SITE_URL}${getCanonicalPath(pathname)}`
);
